import { render, staticRenderFns } from "./RoundQuestions.vue?vue&type=template&id=c7b6acc0&scoped=true&"
import script from "./RoundQuestions.vue?vue&type=script&lang=js&"
export * from "./RoundQuestions.vue?vue&type=script&lang=js&"
import style0 from "./RoundQuestions.vue?vue&type=style&index=0&id=c7b6acc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b6acc0",
  null
  
)

export default component.exports